import { useState, useContext} from 'react';
import { LanguageContext } from '../../index';
import fImg from '@images/faq/faq-right-bg.webp'
import fImg1 from '@images/services/img1.webp'
import fImg2 from '@images/services/img2.webp'

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';



const FaqSectionS2 = (props) => {

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };
    const { language } = useContext(LanguageContext);
    const isPolish = language === 'pl';
    const faqData = [
        {
            id: "1",
            header: isPolish ? "Architekci" : "Architects",
            body: isPolish ? (
                <>
                    <p>Zapraszamy do współpracy Architektów wnętrz, szukających dla swoich Klientów trwałych produktów i
                    solidnych monterów. Umiemy współpracować.
                    Współpraca profesjonalistów przynosi zadowolenie Klientów i dalsze polecenia.</p>
                    {/* <p>Nasze podłogi drewniane klasy premium to połączenie rzemieślniczego kunsztu, nowoczesnej technologii i głębokiego szacunku do natury. Oferujemy szeroką gamę wyselekcjonowanych gatunków drewna, autorskie wybarwienia oraz możliwość indywidualizacji każdego projektu – od deski po sposób wykończenia.</p>
                    <p><strong>Dlaczego warto z nami współpracować?</strong></p>
                    <div className="listservice">
                        <ul>
                            <li>Dedykowane wsparcie projektowe – od etapu koncepcji po finalny montaż.</li>
                            <li>Próbki i materiały – pomagamy w prezentacji klientowi realnego efektu.</li>
                            <li>Elastyczność i personalizacja – każda realizacja może być dopasowana do potrzeb Twojego projektu.</li>
                            <li>Terminowość i jakość – stawiamy na partnerską współpracę i niezawodność.</li>
                        </ul>
                    </div> */}
                </>
            ) : (
                <>
                    <p>We invite interior designers who are looking for durable products and skilled installers for their clients to collaborate with us.
                    We know how to work as a team.
                    Professional cooperation leads to satisfied clients — and future referrals.</p>
                    {/* <p>Our premium wooden floors combine craftsmanship, modern technology, and deep respect for nature. We offer a wide range of selected wood species, original finishes, and the possibility to individualize every project – from the plank to the finish.</p>
                    <p><strong>Why work with us?</strong></p>
                    <div className="listservice">
                        <ul>
                            <li>Dedicated project support – from concept to final installation.</li>
                            <li>Samples and materials – we help present the real effect to your client.</li>
                            <li>Flexibility and personalization – every project can be tailored to your needs.</li>
                            <li>Punctuality and quality – we focus on partnership and reliability.</li>
                        </ul>
                    </div> */}
                </>
            )
        },
        {
            id: "2",
            header: isPolish ? "Monterzy/Parkieciarze" : "Installers/Floor Fitters",
            body: isPolish ? (
                <>
                    <p>Jeżeli jesteś szanowanym i solidnym wykończeniowcem to podejmijmy współpracę. Mamy dla Twoich
                    Klientów bardzo trwałą podłogę dębową, pod wieloma względami bezkonkurencyjną. Odezwij się do nas!</p>
                    {/* <p>Nasze podłogi drewniane to synonim trwałości, precyzji i elegancji. Dbamy o każdy etap produkcji – od wyboru surowca po finalne wykończenie – by oddać w Twoje ręce produkt, który montuje się z przyjemnością i satysfakcją.</p>
                    <p><strong>Co oferujemy?</strong></p>
                    <div className="listservice">
                        <ul>
                            <li>Wysokiej jakości materiały – deski idealnie przygotowane do montażu, stabilne i sprawdzone.</li>
                            <li>Wsparcie techniczne – zawsze możesz liczyć na naszą wiedzę i pomoc w doborze technologii.</li>
                            <li>Stałą współpracę i korzystne warunki – szanujemy Twój czas i pracę, dlatego oferujemy uczciwe zasady.</li>
                            <li>Szkolenia i rozwój – dzielimy się doświadczeniem i nowinkami z branży.</li>
                        </ul>
                    </div> */}
                </>
            ) : (
                <>
                    <p>If you're a respected and reliable finishing professional, let’s work together.
                    We offer your clients a highly durable oak floor that’s truly unmatched in many aspects.
                    Get in touch with us!</p>
                    {/* <p>Our wooden floors are synonymous with durability, precision, and elegance. We care about every stage of production – from raw material selection to the final finish – to deliver a product you’ll enjoy installing.</p>
                    <p><strong>What do we offer?</strong></p>
                    <div className="listservice">
                        <ul>
                            <li>High-quality materials – planks perfectly prepared for installation, stable and proven.</li>
                            <li>Technical support – you can always count on our knowledge and help in choosing the right technology.</li>
                            <li>Ongoing cooperation and favorable terms – we respect your time and work, so we offer fair conditions.</li>
                            <li>Training and development – we share experience and industry news.</li>
                        </ul>
                    </div> */}
                </>
            )
        },
        {
            id: "3",
            header: isPolish ? "Kontrahenci" : "Business Partners",
            body: isPolish ? (
                <>
                    <p>Jeżeli jesteś dostawcą sprawdzonych i trwałych produktów lub usług napisz do nas salonfabri@gmail.com</p>
                    {/* <p>Współpracujemy z kontrahentami w całej Polsce i za granicą – od salonów wnętrzarskich, przez inwestorów i deweloperów, aż po wyspecjalizowane firmy wykonawcze. Nasza oferta to więcej niż produkt – to wartość, która przyciąga wymagających klientów i wyróżnia ofertę na rynku.</p>
                    <p><strong>Dlaczego warto?</strong></p>
                    <div className="listservice">
                        <ul>
                            <li>Produkt klasy premium – naturalne drewno, unikalne wykończenia, dbałość o każdy detal.</li>
                            <li>Elastyczne warunki współpracy – dopasowane do Twojego modelu biznesowego.</li>
                            <li>Wsparcie sprzedażowe i marketingowe – materiały reklamowe, szkolenia, dostęp do próbek.</li>
                            <li>Stabilność i terminowość – wiemy, jak ważna jest niezawodność w biznesie.</li>
                        </ul>
                    </div> */}
                </>
            ) : (
                <>
                    <p>If you're a supplier of proven and durable products or services, write to us at salonfabri@gmail.com.</p>
                    {/* <p>We work with partners throughout Poland and abroad – from interior showrooms, investors, and developers to specialized contractors. Our offer is more than just a product – it’s value that attracts demanding clients and distinguishes your offer on the market.</p>
                    <p><strong>Why is it worth it?</strong></p>
                    <div className="listservice">
                        <ul>
                            <li>Premium product – natural wood, unique finishes, attention to every detail.</li>
                            <li>Flexible cooperation terms – tailored to your business model.</li>
                            <li>Sales and marketing support – advertising materials, training, access to samples.</li>
                            <li>Stability and punctuality – we know how important reliability is in business.</li>
                        </ul>
                    </div> */}
                </>
            )
        },
        {
            id: "4",
            header: isPolish ? "Klienci indywidualni" : "Individual Clients",
            body: isPolish ? (
                <>
                    <p>Z Dębu stworzymy dla Ciebie Wszystko. Mamy za sobą setki realizacji, a każda inna, gdyż po prostu
                    spełniamy indywidualne marzenia. Jest tylko jeden warunek - musisz chcieć produkty wysokiej jakości.
                    Wbij w telefon numer 538368480 i kliknij połącz :)</p>
                    {/* <p>Każda nasza deska to efekt rzemieślniczego kunsztu, starannej selekcji drewna i pasji do tworzenia ponadczasowych rozwiązań. Dzięki indywidualnemu podejściu możesz mieć pewność, że podłoga idealnie dopełni charakter Twojego wnętrza – niezależnie od stylu.</p>
                    <p><strong>Dlaczego warto wybrać nasze podłogi?</strong></p>
                    <div className="listservice">
                        <ul>
                            <li>Naturalne, szlachetne drewno – trwałe, ekologiczne, piękne z wiekiem.</li>
                            <li>Wyjątkowe wykończenia i kolory – możliwość dopasowania do Twojego gustu i stylu życia.</li>
                            <li>Jakość, którą czuć i widać – precyzja wykonania i przyjemność użytkowania przez długie lata.</li>
                            <li>Doradztwo i wsparcie – pomożemy Ci wybrać idealne rozwiązanie, bez stresu i kompromisów.</li>
                        </ul>
                    </div> */}
                </>
            ) : (
                <>
                    <p>We can create anything from oak – just for you.
                    We’ve completed hundreds of projects, each one unique, because we simply make individual dreams come true.
                    There’s only one condition: you have to want high-quality products.
                    Type +48 538 368 480 into your phone and hit call 😊</p>
                    {/* <p>Each of our planks is the result of craftsmanship, careful wood selection, and a passion for creating timeless solutions. Thanks to our individual approach, you can be sure your floor will perfectly complement your interior – regardless of style.</p>
                    <p><strong>Why choose our floors?</strong></p>
                    <div className="listservice">
                        <ul>
                            <li>Natural, noble wood – durable, ecological, beautiful with age.</li>
                            <li>Unique finishes and colors – possibility to match your taste and lifestyle.</li>
                            <li>Quality you can feel and see – precision workmanship and years of enjoyment.</li>
                            <li>Advice and support – we’ll help you choose the perfect solution, stress-free and without compromise.</li>
                        </ul>
                    </div> */}
                </>
            )
        }
    ];

    return (
        <section className="faq-section mt-150">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-6 pr-125 rpr-15">
                        <div className="service-page-images rmb-150">
                            <img src={fImg1} alt="Services"/>
                            <img src={fImg2} alt="Service"/>
                        </div>
                    </div>
                    <div className="col-lg-6 pl-0">
                        <div className="faq-accordion ras-content pt-95 pb-110 rpb-0 rmb-100">
                            <div className="section-title mb-35">
                                <h6>{isPolish ? "Możliwość współpracy" : "Cooperation Opportunities"}</h6>
                                <h2>
                                    {isPolish ? "Zapraszamy do kooperacji" : "We invite you to cooperate"}
                                    <span className="thin"> {isPolish ? "z Fabri" : "with Fabri"}</span>
                                </h2>
                            </div>
                            <div id="accordion">
                                <Accordion open={open} toggle={toggle}>
                                    {faqData.map(({ id, header, body }) => (
                                        <AccordionItem className='card' key={id}>
                                            <AccordionHeader targetId={id} className='card-header'>{header}</AccordionHeader>
                                            <AccordionBody accordionId={id}>
                                                {body}
                                            </AccordionBody>
                                        </AccordionItem>
                                    ))}
                                </Accordion>
                            </div>
                        </div>
                        <div className="faq-right-bg">
                            <img src={fImg} alt="FAQ" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}


export default FaqSectionS2;